import React from 'react';
import VideoPlayerBlock from 'libs/wordpress/content/cmsBlocks/VideoPlayerBlock';
import moduleMargins from 'config/theme/moduleMargins';
import styled from 'libs/styled';

const Section = styled('section')``;

const VideoPlayerModule = ({ ...rest }) => (
    <Section mt={moduleMargins.md}>
        <VideoPlayerBlock {...rest} />
    </Section>
);

export default VideoPlayerModule;
